<template>
  <div class="register bg-animation-contianer">
    <ul class="bg-bubbles">
      <li class="ball bubble" v-for="i in 10" :key="i"></li>
    </ul>
    <div class="waveWrapper waveAnimation">
      <div class="waveWrapperInner bgTop">
        <div class="wave waveTop"></div>
      </div>
      <div class="waveWrapperInner bgMiddle">
        <div class="wave waveMiddle" ></div>
      </div>
      <div class="waveWrapperInner bgBottom">
        <div class="wave waveBottom"></div>
      </div>
    </div>
    <router-link tag="a" to="/" class="login-register-logo">
      <img src="@/assets/images/login-log.png" width="170" alt="">
    </router-link>
    <div class="login-register-container">
      <div class="login-register-form-container">
        <div class="container-left clearfix">
          <div class="iamge-wrapper">
            <div class="txt-container">
              <div class="title-big">专业的店铺客服系统</div>
              <div class="title-small">微商经营店铺必备</div>
            </div>
            <img src="@/assets/images/login-image.png" alt="">
          </div>
        </div>
        <div class="clearfix container-right">
          <ul class="tab-title clearfix">
            <li @click="toLogin">用户登录</li>
            <li class="tab-title-actived">立即注册</li>
          </ul>
          <ul class="login-register-form">
            <li>
              <!--<span class="form-label">团队或企业全称</span>--><input type="text" ref="teamName" v-model="registerForm.name"
                                                            placeholder="请输入团队或企业全称" autocomplete="off">
            </li>
            <li>
              <!--<span class="form-label">手机号码</span>--><input type="text" v-model="registerForm.account" maxlength="11" placeholder="请输入手机号"
                                                         autocomplete="off">
            </li>
            <li>
              <!--<span class="form-label">登录密码</span>--><input type="password" v-model="registerForm.password" maxlength="32"
                                                         placeholder="请输入6~32位密码" autocomplete="off">
            </li>
            <li>
              <!--<span class="form-label">确认登录密码</span>--><input type="password" v-model="registerForm.confirm_password" maxlength="32"
                                                           placeholder="请确认登录密码" autocomplete="off">
            </li>
            <li>
             <!-- <span class="form-label">安全验证</span>-->
              <input type="text" class="authCode" v-model="registerForm.verify" placeholder="验证码" autocomplete="off">
              <span class="authCodeImg"><img :src="verifyImg" alt="图片验证码" @click="changeVerify"></span>
              <span class="changeAuthCode"><span @click="changeVerify">换一张</span></span>
            </li>
            <li>
              <!--<span class="form-label">手机验证码</span>-->
              <input type="text" class="phoneAuthCode" v-model="registerForm.mobile_code" placeholder="手机验证码">
              <span class="sendMsgCode" :disabled="!canSendMsg" @click="sendMsg">{{sendMsgBtnTxt}}</span>
            </li>
          </ul>
          <div class="form-submit-btn-box">
            <el-button type="primary" class="form-submit-btn" @click="handleRegister" :loading="isLoading">立即注册
            </el-button>
          </div>
        </div>

      </div>
    </div>
    <!--<div class="register-login-info">©启博科技专注于粉丝生态</div>-->
  </div>
</template>

<script>
  export default {
    name: 'register',
    data() {
      return {
        isLoading: false,
        canSendMsg: true,
        sendMsgTimer: null,
        sendMsgTime: 60,
        sendMsgBtnTxt: '发送验证码',
        registerForm: {
          name: '',
          account: '',
          password: '',
          confirm_password: '',
          verify: '',
          mobile_code: '',
          sid: ''
        },
        verifyRandom: ''
      }
    },
    computed: {
      verifyImg() {
        return process.env.VUE_APP_API_URL + '/wlapi/public/verifyCode?=' + this.verifyRandom
      }
    },
    methods: {
      /**
       * 修改图片验证码
       */
      changeVerify() {
        this.verifyRandom = new Date().getTime()
      },
      /**
       * 获取短信验证码
       */
      sendMsg() {
        let checkPhone = this.$utils.u_checkMobile(this.registerForm.account)
        if (this.$utils.u_isEmpty(this.registerForm.name)) {
          this.$message({
            message: ' 请输入团队或企业全称',
            type: 'error'
          })
          return false
        }
        if (this.$utils.u_isEmpty(this.registerForm.account)) {
          this.$message({
            message: ' 请输入手机号',
            type: 'error'
          })
          return false
        }
        if (!checkPhone) {
          this.$message({
            message: ' 手机号格式不正确',
            type: 'error'
          })
          return false
        }
        if (this.$utils.u_isEmpty(this.registerForm.password)) {
          this.$message({
            message: ' 请输入密码',
            type: 'error'
          })
          return false
        }
        if (this.$utils.u_isEmpty(this.registerForm.confirm_password)) {
          this.$message({
            message: ' 请确认密码',
            type: 'error'
          })
          return false
        }
        if (this.registerForm.password != this.registerForm.confirm_password) {
          this.$message({
            message: ' 两次输入的密码不一致',
            type: 'error'
          })
          return false
        }
        if (this.$utils.u_isEmpty(this.registerForm.verify)) {
          this.$message({
            message: ' 请输入验证码',
            type: 'error'
          })
          return false
        }
        if (!this.canSendMsg) {
          return false
        }

        let postParams = {
          name: this.registerForm.name,
          account: this.registerForm.account,
          password: this.registerForm.password,
          confirm_password: this.registerForm.confirm_password,
          verify: this.registerForm.verify,
        }
        this.$http.getMsgCodeAPI(postParams).then(res => {
          if (res.status == 1) {
            this.canSendMsg = false
            this.sendMsgTimer = setInterval(() => {
              this.sendMsgTime--
              if (this.sendMsgTime > 0) {
                this.sendMsgBtnTxt = '已发送(' + this.sendMsgTime + 's)'
              } else {
                this.sendMsgBtnTxt = '发送验证码'
                this.canSendMsg = true
                this.sendMsgTime = 60
                clearInterval(this.sendMsgTimer)
              }
            }, 1000)
            this.$message({
              message: res.msg,
              type: 'success'
            })
          } else {
            this.$message({
              message: res.msg,
              type: 'error'
            })
            this.verifyRandom = new Date().getTime()
          }
        })

      },
      toLogin() {
        this.$router.push({
          path: '/login'
        })
      },
      handleRegister() {
        let checkPhone = this.$utils.u_checkMobile(this.registerForm.account)
        if (this.$utils.u_isEmpty(this.registerForm.name)) {
          this.$message({
            message: ' 请输入团队或企业全称',
            type: 'error'
          })
          return false
        }
        if (this.$utils.u_isEmpty(this.registerForm.account)) {
          this.$message({
            message: ' 请输入手机号',
            type: 'error'
          })
          return false
        }
        if (!checkPhone) {
          this.$message({
            message: ' 手机号格式不正确',
            type: 'error'
          })
          return false
        }
        if (this.$utils.u_isEmpty(this.registerForm.password)) {
          this.$message({
            message: ' 请输入密码',
            type: 'error'
          })
          return false
        }
        if (this.$utils.u_isEmpty(this.registerForm.confirm_password)) {
          this.$message({
            message: ' 请确认密码',
            type: 'error'
          })
          return false
        }
        if (this.registerForm.password != this.registerForm.confirm_password) {
          this.$message({
            message: ' 两次输入的密码不一致',
            type: 'error'
          })
          return false
        }
        if (this.$utils.u_isEmpty(this.registerForm.verify)) {
          this.$message({
            message: ' 请输入验证码',
            type: 'error'
          })
          return false
        }
        if (this.$utils.u_isEmpty(this.registerForm.mobile_code)) {
          this.$message({
            message: ' 请输入短信验证码',
            type: 'error'
          })
          return false
        }
        this.isLoading = true
        this.$store.dispatch('user/register', this.registerForm).then(res => {
          if (res.status == 1) {
            this.$router.push({
              path: '/login'
            })
          } else {
            this.verifyRandom = new Date().getTime()
          }
          this.isLoading = false
        }).catch(err => {
          this.isLoading = false
        })
      }
    },
    created() {
      this.verifyRandom = new Date().getTime()
    },
    mounted() {
      this.$refs.teamName.focus()
    }
  }
</script>

<style lang="scss">
  .register {
    width: 100%;
    height: 100%;
    &.bg-animation-contianer {
      background-image: linear-gradient(111deg,
          #2572fd 5%,
          #256cff 51%,
          #2797ff 100%);
      position: relative;
      .bg-bubbles {
        position: absolute;
        // 使气泡背景充满整个屏幕；
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        margin: 0;
        padding: 0;
        z-index: 2;
        // 如果元素内容超出给定的宽度和高度，overflow 属性可以确定是否显示滚动条等行为；
        overflow: hidden;
        li {
          position: absolute;
          // bottom 的设置是为了营造出气泡从页面底部冒出的效果；
          bottom: -140px;
          // 默认的气泡大小；
          width: 50px;
          height: 50px;
          border-radius: 50%;
          /*background-color: rgba(255, 255, 255, 0.15);*/
          list-style: none;

          background: radial-gradient(circle at 100px 100px, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.5));

          // 使用自定义动画使气泡渐现、上升和翻滚；
          /*animation: square 5s infinite;*/
          /*transition-timing-function: linear;*/
          // 分别设置每个气泡不同的位置、大小、透明度和速度，以显得有层次感；
          &:nth-child(1) {
            left: 8%;
            animation: square 10s 8s linear infinite;
          }
          &:nth-child(2) {
            left: 20%;
            width: 90px;
            height: 90px;
            animation: square 10s 5s linear infinite;
          }
          &:nth-child(3) {
            left: 25%;
            animation: square 10s 1s linear infinite;
          }
          &:nth-child(4) {
            left: 40%;
            width: 60px;
            height: 60px;
            animation: square 10s 2s linear infinite;
          }
          &:nth-child(5) {
            left: 65%;
            animation: square 10s 9.8s linear infinite;
          }
          &:nth-child(6) {
            left: 79%;
            width: 120px;
            height: 120px;
            animation: square 10s 7.2s linear infinite;
            /*background-color: rgba(255, 255, 255, 0.2);*/
          }
          &:nth-child(7) {
            left: 32%;
            width: 140px;
            height: 140px;
            animation: square 10s 3s linear infinite;
          }
          &:nth-child(8) {
            left: 55%;
            width: 20px;
            height: 20px;
            animation: square 10s 4.9s linear infinite;
          }
          &:nth-child(9) {
            left: 28%;
            width: 15px;
            height: 15px;
            animation: square 10s 6.5s linear infinite;
            /*background-color: rgba(255, 255, 255, 0.3);*/
          }
          &:nth-child(10) {
            left: 95%;
            width: 130px;
            height: 130px;
            animation: square 10s 4.3s linear infinite;
          }
        }
        // 自定义 square 动画；
        @keyframes square {
          0% {
            opacity: 0.5;
            transform: translate(0px, 0px);
          }
          25% {
            opacity: 0.75;
            transform: translate(0px,-500px);
          }
          50% {
            opacity: 1;
            transform: translate(0px,-1000px);
          }
          75% {
            opacity: 0.75;
            transform: translate(0px,-1500px);
          }
          100% {
            opacity: 0;
            transform: translate(0px, -2000px);
          }
        }
      }
      .ball {
        display: inline-block;
        width: 100px;
        height: 100px;
        border-radius: 100%;
        position: relative;
        background: radial-gradient(circle at bottom,  rgba(255,255,255,0.1),  rgba(255,255,255,0.1) 10%, rgba(255,255,255,0.1) 80%, rgba(255,255,255,0.1) 100%); }
      .ball:before {
        content: "";
        position: absolute;
        top: 1%;
        left: 5%;
        width: 90%;
        height: 90%;
        border-radius: 100%;
        background: radial-gradient(circle at top, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0) 48%);
        -webkit-filter: blur(5px);
        filter: blur(5px);
        z-index: 2; }
      .ball:after {
        content: "";
        position: absolute;
        display: none;
        top: 5%;
        left: 10%;
        width: 80%;
        height: 80%;
        border-radius: 100%;
        -webkit-filter: blur(1px);
        filter: blur(1px);
        z-index: 2;
      }
      @keyframes move_wave {
        0% {
          transform: translateX(0) translateZ(0) scaleY(1)
        }
        50% {
          transform: translateX(-25%) translateZ(0) scaleY(0.55)
        }
        100% {
          transform: translateX(-50%) translateZ(0) scaleY(1)
        }
      }
      .waveWrapper {
        overflow: hidden;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        margin: auto;
        z-index: 1;
      }
      .waveWrapperInner {
        position: absolute;
        width: 100%;
        overflow: hidden;
        height: 100%;
        bottom: -1px;
      }
      .bgTop {
        z-index: 15;
        opacity: 0.5;
      }
      .bgMiddle {
        z-index: 10;
        opacity: 0.75;
      }
      .bgBottom {
        z-index: 5;
      }
      .wave {
        position: absolute;
        left: 0;
        width: 200%;
        height: 100%;
        background-repeat: repeat no-repeat;
        background-position: 0 bottom;
        transform-origin: center bottom;
      }
      .waveTop {
        background-image: url("~@/assets/images/wave/wave-top.png");
        background-size: 50% 160px;
      }
      .waveMiddle{ background-image: url("~@/assets/images/wave/wave-mid.png");}
      .waveBottom{ background-image: url("~@/assets/images/wave/wave-bot.png");}
      .waveAnimation .waveTop {
        animation: move-wave 3s;
        -webkit-animation: move-wave 3s;
        -webkit-animation-delay: 1s;
        animation-delay: 1s;
      }
      .waveMiddle {
        background-size: 50% 130px;
      }
      .waveAnimation .waveMiddle {
        animation: move_wave 10s linear infinite;
      }
      .waveBottom {
        background-size: 50% 160px;
      }
      .waveAnimation .waveBottom {
        animation: move_wave 15s linear infinite;
      }
    }
    .login-register-logo{
      position: fixed;
      top: 36px;
      left: 41px;
      z-index: 9;
    }
    .login-register-container {
      width: 748px;
      margin: 0 auto;
      position: absolute;
      top: 40%;
      left: 50%;
      transform: translate(-50%, -40%);
      z-index: 2;
      overflow: hidden;
      padding: 45px 35px;
      box-shadow: 0 0 18px 1px rgba(0,0,0,.2);
      background-color: #fff;
      border-radius: 15px;
      box-sizing: border-box;
      .container-left{
        width: 50%;
        float: left;
        padding-right: 30px;
        box-sizing: border-box;
        .iamge-wrapper{
          width: 310px;
          height: 325px;
          position: relative;
          img{
            width: 100%;
          }
          .txt-container{
            position: absolute;
            left: 0;
            right: 0;
            top: 40px;
            text-align: center;
            .title-big{
              font-size: 20px;
              color: #0f0f0f;
              font-weight: bold;
            }
            .title-small{
              font-size: 13px;
              color: #999999;
              margin-top: 14px;
            }
          }
        }
      }
      .container-right{
        width: 50%;
        float: right;
      }
      .login-register-form-container {
        display: flex;
        align-items: center;
        .tab-title {
          display: flex;
          justify-content: space-between;
          li {
            font-size: 20px;
            cursor: pointer;
            &.tab-title-actived {
              color: #409eff;
              border-bottom: 2px solid #409eff;
              padding-bottom: 18px;
            }
          }
        }
        .login-register-form {
          font-size: 14px;
          color: #595961;
          padding: 0;
          margin: 0;
          li {
            display: flex;
            border-bottom: 1px solid #eee;
            height: 60px;
            line-height: 50px;
            align-items: center;
            input {
              border: none;
              flex: 1;
              outline: none;
            }
            .form-label {
              padding-right: 20px;
            }
            .authCode {
              width: 50px;
            }
            .authCodeImg {
              display: flex;
              align-items: center;
              width: 120px;
              padding: 0 5px;
              img {
                display: block;
                width: 100%;
                height: 40px;
                cursor: pointer;
              }
            }
            .changeAuthCode {
              span {
                cursor: pointer;
                color: #0E64A0;
                font-size: 12px;
                &:hover {
                  border-bottom: 1px solid #0E64A0;
                }
              }
            }
            .phoneAuthCode {
              width: 100px;
            }
            .sendMsgCode {
              background-color: #83ba21;
              color: #fff;
              padding: 0 20px;
              height: 40px;
              line-height: 40px;
              margin-top: 5px;
              cursor: pointer;
              &[disabled] {
                background-color: #888888;
                cursor: not-allowed;
              }
            }
          }
        }
        .form-submit-btn-box {
          padding-top: 15px;
          .form-submit-btn {
            width: 100%;
          }
        }

      }
    }
    .register-login-info {
      text-align: center;
      position: absolute;
      bottom: 10px;
      right: 0;
      left: 0;
      color: #595961;
      font-size: 12px;
      z-index: 1;
    }
  }
</style>
